import { ImportOutlined, PlusOutlined, SaveOutlined, InfoCircleOutlined, InfoCircleTwoTone, DownloadOutlined } from '@ant-design/icons'
import { Tag, Button, Col, Modal, PageHeader, Row, Tooltip } from 'antd'
import * as React from 'react'
import moment from 'moment'

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'
import { IRaccoltaDatiService } from '../../services/RaccoltaDatiService'

import { formatEuro } from '../shared/CurrencyFormat'
import { ImportYapilyMovimentiModel, Movimento, RaccoltaDatiModel, Saldo } from '../../models/RaccoltaDatiModels'

import { IAppContext, withAppContext } from '../AppContext'
import { TTFormItem } from '../shared/TTFormItem'
import { TTInputCurrency } from '../shared/TTInputCurrency'
import { MonthSwitcher } from '../MonthSwitcher'
import { ModalCategoria, OperationType } from '../configurazione/ModalCategoria'
import { ModalMovimento } from './ModalMovimento'
import { ModalSaldo } from './ModalSaldo'
import { ModalImportMovimenti } from './ModalImportMovimenti'
import { TableEntrate } from './TableEntrate'
import { TableUscite } from './TableUscite'
import { TableSaldoCC } from './TableSaldoCC'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ai } from '../../TelemetryService'


class PageRaccoltaDatiState extends RaccoltaDatiModel {
    ModalMovimentoVisible: boolean = false
    MovimentoId: string

    ModalSaldoVisible: boolean = false
    SaldoModel: Saldo

    ModalCategoriaVisible: boolean = false
    ModalImportVisible: boolean = false
    ModalImportFEVisible: boolean = false
}

class PageRaccoltaDatiComp extends React.Component<IAppContext, PageRaccoltaDatiState> {

    service: IRaccoltaDatiService

    constructor(props) {
        super(props)
        this.state = new PageRaccoltaDatiState()
        this.service = container.get(SERVICE_IDENTIFIER.RACCOLTA_DATI_SERVICE)
    }

    componentDidMount() {
        let date = moment([this.props.appContext.Anno, moment().month()])
        this.loadPage(date.format("YYYY/MM/DD") as any)
    }

    componentDidUpdate(prevProps: IAppContext) {
        if (prevProps.appContext.Anno != this.props.appContext.Anno) {

            let date = moment([this.props.appContext.Anno, moment(this.state.Periodo).month()])
            this.loadPage(date.format("YYYY/MM/DD") as any)
        }
    }

    loadPage = async (periodo: Date) => {
        this.setState({ Periodo: periodo })

        let resp = await this.service.Get(periodo)
        if (resp.IsValid == true)
            this.setState(resp)
    }

    onSave = async () => {
        await this.service.Save(this.state)
    }

    openMovimentoModal = (record: Movimento) => {
        this.setState({
            ModalMovimentoVisible: true,
            MovimentoId: record.Id
        })
    }

    closeMovimentoModal = () => {
        this.setState({
            ModalMovimentoVisible: false,
            MovimentoId: null
        })
    }

    openSaldoModal = (record: Saldo) => {
        this.setState({
            ModalSaldoVisible: true,
            SaldoModel: record
        })
    }

    closeSaldoModal = () => {
        this.setState({
            ModalSaldoVisible: false,
            SaldoModel: null
        })
    }

    toggleModalCategoria = (visible: boolean) => {
        this.setState({ ModalCategoriaVisible: visible })
    }

    toggleModalImport = (visible: boolean) => {
        this.setState({ ModalImportVisible: visible })
    }

    toggleModalImportFE = (visible: boolean) => {
        window.location.href = "/ImportFEManuali"
        //this.setState({ ModalImportFEVisible: visible })
    }

    downloadMovimenti = () => {
        Modal.confirm({
            title: "Conferma download movimenti",
            content: "Scaricare movimenti?",
            onOk: async () => {
                let model = new ImportYapilyMovimentiModel()
                model.Periodo = this.state.Periodo
                let resp = await this.service.DownloadMovimenti(model)
                if (resp.IsValid == true) {
                    resp = await this.service.DownloadSaldo()
                    if (resp.IsValid == true)
                        this.loadPage(this.state.Periodo)
                }
            }
        })
    }

    deleteMovimento = (data: Movimento) => {
        Modal.confirm({
            title: "Eliminazione movimento",
            content: "Eliminare il movimento?",
            onOk: async () => {
                let resp = await this.service.DeleteMovimento(data.Id)
                if (resp.IsValid == true)
                    this.loadPage(this.state.Periodo)
            }
        })
    }

    renderCreditiNonSaldati = (value?: number) => {
        if (!this.state.ConfigFatturazione || value == null) return "";
        let euro = formatEuro(value);
        let tooltip = "Crediti non saldati " + euro + ". Il valore visualizzato è stato letto dalle scadenze non pagate delle fatture di Vendita";
        return this.renderTooltip(tooltip);
    }

    renderDebitiNonSaldati = (value?: number) => {
        if (!this.state.ConfigFatturazione || value == null) return "";
        let euro = formatEuro(value);
        let tooltip = "Debiti non saldati " + euro + ". Il valore visualizzato è stato letto dalle scadenze non pagate delle fatture di Acquisto";
        return this.renderTooltip(tooltip);
    }

    renderTooltip = (title: string) => {
        return <Tooltip placement="right" title={title}><InfoCircleTwoTone twoToneColor="#1890ff" /></Tooltip>;
    }

    render() {
        return (
            <>
                <ModalCategoria
                    visible={this.state.ModalCategoriaVisible}
                    closeModal={() => this.toggleModalCategoria(false)} op={OperationType.ADD} />

                <ModalImportMovimenti
                    visible={this.state.ModalImportVisible}
                    closeModal={() => this.toggleModalImport(false)}
                    do={() => this.loadPage(this.state.Periodo)}
                    periodo={this.state.Periodo} />

                <PageHeader title="Raccolta dati" style={{ paddingBottom: '0px' }} extra={[
                    <Button type="primary" key="new-ca" icon={<PlusOutlined />} onClick={() => this.toggleModalCategoria(true)}>Crea categoria</Button>,
                    <Button type="primary" key="import" icon={<ImportOutlined />} onClick={() => this.toggleModalImport(true)}>Importa movimenti</Button>,
                    // todo: gestire la visibilità del pulsante
                    <Button type="primary" key="download-mov" icon={<DownloadOutlined />} onClick={() => this.downloadMovimenti()}>Scarica movimenti</Button>,
                    <Button type="primary" key="import-fe" icon={<ImportOutlined />} onClick={() => this.toggleModalImportFE(true)}>Importazione fatture elettroniche</Button>
                ]}>
                    <MonthSwitcher value={moment(this.state.Periodo)} onChange={e => this.loadPage(e.format() as any)} />
                </PageHeader>
                <PageHeader title="" style={{ paddingTop: '0px' }} extra={[
                    <Button type="primary" key="save" icon={<SaveOutlined />} onClick={() => this.onSave()}>Salva</Button>
                ]}>
                    <Row gutter={[10, 30]}>
                        <Col xs={24} lg={12} xl={6}>
                            <TTFormItem label="Fatturato" required={true}>
                                <TTInputCurrency style={{ width: '100%', marginRight:0 }} value={this.state.Fatturato} onChange={e => this.setState({ Fatturato: e as number })} />
                            </TTFormItem>
                        </Col>
                        <Col xs={24} lg={12} xl={6}>
                            <TTFormItem label="Crediti Scaduti" required={true}>
                                <TTInputCurrency style={{ width: '100%' }} value={this.state.Crediti} onChange={e => this.setState({ Crediti: e as number })} /> {this.renderCreditiNonSaldati(this.state.CreditiNonSaldati)}
                            </TTFormItem>
                        </Col>
                        <Col xs={24} lg={12} xl={6}>
                            <TTFormItem label="Debiti Scaduti" required={true}>
                                <TTInputCurrency style={{ width: '100%' }} value={this.state.Debiti} onChange={e => this.setState({ Debiti: e as number })} /> {this.renderDebitiNonSaldati(this.state.DebitiNonSaldati)}
                            </TTFormItem>
                        </Col>
                        <Col xs={24} lg={12} xl={6}>
                            <TTFormItem label="Incassato">
                                {formatEuro(this.state.Incassato)}
                            </TTFormItem>
                        </Col>
                    </Row>

                    <TableSaldoCC
                        saldi={this.state.Saldi}
                        onSaldoEdit={record => this.openSaldoModal(record)} />
                    <br />
                    <br />

                    {this.state.ModalSaldoVisible ?
                        <ModalSaldo
                            data={this.state.SaldoModel}
                            visible={this.state.ModalSaldoVisible}
                            closeModal={() => this.closeSaldoModal()}
                            do={() => this.loadPage(this.state.Periodo)} /> : <></>
                    }

                    <TableUscite
                        uscite={this.state.Uscite}
                        onEditMovimento={record => this.openMovimentoModal(record)}
                        onDeleteMovimento={record => this.deleteMovimento(record)} />

                    <TableEntrate entrate={this.state.Entrate}
                        onDeleteMovimento={record => this.deleteMovimento(record)} />

                    {this.state.ModalMovimentoVisible ?
                        <ModalMovimento
                            id={this.state.MovimentoId}
                            visible={this.state.ModalMovimentoVisible}
                            closeModal={() => this.closeMovimentoModal()}
                            do={() => this.loadPage(this.state.Periodo)} /> : <></>
                    }

                </PageHeader>
            </>
        )
    }
}

export const PageRaccoltaDati = withAppContext(withAITracking(ai.reactPlugin, PageRaccoltaDatiComp,"PageRaccoltaDati"))